<section class="container mt-5">
    <h2 class="tituloEventos">Todos los Promotores</h2>
    <div *ngIf='message' class="alert alert-success ">{{message}}</div>
    <div class="row">
        <div class="col-12 mt-5  btnAdd" style="text-align: center;">
            <button routerLink="agregar" class="btn btn-primary">Agregar Promotor</button>
        </div>
    </div>
    <div class="container containerTabla">
        <table class="table mt-3 contenedorLista">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Nombre</th>
                    <th class="v-desktop">Modificar</th>
                    <th class="v-desktop">Pagar Al Promotor</th>
                    <th class="v-desktop">Ver Eventos del promotor</th>
                    <th class="v-desktop">Borrar</th>
                    <th class="v-mobile">Opciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let promotor of promotores" class="filasEventos">
                    <td>{{promotor?.numeroDocumento}}</td>
                    <td>{{promotor?.nombre }}</td>
                    <td class="v-desktop"><button routerLink='update/{{promotor.numeroDocumento}}' class="btn btn-warning">
                            Modificar</button></td>
                    <td class="v-desktop"><button class="btn btn-warning" routerLink='boletasAPagar/{{promotor.numeroDocumento}}'>Pagar
                        </button></td>
                    <td class="v-desktop"><button class="btn btn-success" routerLink='agregar-evento/{{promotor.numeroDocumento}}'>Ver
                        </button></td>
                    <td class="v-desktop"><button (click)="borrar(promotor.numeroDocumento)" class="btn btn-danger"> Borrar</button></td>
                    
                    <td class="options v-mobile">
                        <a routerLink='update/{{promotor.numeroDocumento}}'><mat-icon>mode</mat-icon></a>
                        <a routerLink='boletasAPagar/{{promotor.numeroDocumento}}'><mat-icon>monetization_on</mat-icon></a>
                        <a routerLink='agregar-evento/{{promotor.numeroDocumento}}'><mat-icon>visibility</mat-icon></a>
                        <a (click)="borrar(promotor.numeroDocumento)"><mat-icon>delete</mat-icon></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</section>